import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/components/docs/DocsSidebar.tsx");
